// Single source of truth for RTDB key strings used by the share model.
// Mirrors functions/shareLinks.js and the iOS RTDBKeys enum so backend
// renames surface as a single-file change instead of grep-and-replace
// across components.

// Global link state lives at /artists/{aId}/projects/{pId}[/tracks/{tId}]/
// links/global, sibling to metadata. CFs (setProjectAccessMode etc.) are
// the only writers; clients read directly via RTDB rules.
export const GlobalLinkKeys = {
    currentSlug: 'currentSlug',
    settings: 'settings',
    accessMode: 'access mode',
    allowEditing: 'allow editing',
    allowDownloads: 'allow downloads',
    requireAccount: 'require account',
    passwordHash: 'password hash',
};

export const GrantedViewerKeys = {
    permission: 'permission',
    lastVia: 'last via',
    lastSourceId: 'last source id',
    grantedAt: 'granted at',
    lastRedeemedAt: 'last redeemed at',
};

// Inbox lives at /users/{uid}/openedShareLinks/{global|invite}/{slug|token}.
// Global entries are slug-keyed; invite entries are token-keyed.
export const InboxKeys = {
    openedShareLinks: 'openedShareLinks',
    global: 'global',
    invite: 'invite',
    targetType: 'target type',
    artistId: 'artist id',
    projectId: 'project id',
    permission: 'permission',
    lastOpenedAt: 'last opened at',
    firstOpenedAt: 'first opened at',
    openCount: 'open count',
    trackId: 'track id',
    lyricsId: 'lyrics id',
    ideaId: 'idea id',
};

export const ShareLinkKeys = {
    token: 'token',
    url: 'url',
    targetType: 'target type',
    permission: 'permission',
    createdAt: 'created at',
    createdBy: 'created by',
    expiresAt: 'expires at',
    maxUses: 'max uses',
    useCount: 'use count',
    hasPassword: 'hasPassword',
    revoked: 'revoked',
    passwordHash: 'password hash',
    trackId: 'track id',
    lyricsId: 'lyrics id',
    ideaId: 'idea id',
};

export const ViewerKeys = {
    uid: 'uid',
    firstOpenedAt: 'first opened at',
    lastOpenedAt: 'last opened at',
    openCount: 'open count',
    lastVia: 'last via',
    lastSourceId: 'last source id',
};

// /users/{uid}/publicProfile/ — readable by any authenticated user. The
// minimum data needed for foreign-uid display name resolution (member
// lists, share-link viewer dashboards, comment authors). Owners write
// here via User.setName + the signup flow fans out alongside legacy
// /metadata writes.
export const PublicProfileKeys = {
    publicProfile: 'publicProfile',
    firstName: 'first name',
    lastName: 'last name',
};
